import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServiceContractEditor.html?raw';
import lang from 'dojo/_base/lang';

import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import _GlobalSelectEntityDialogsMixin from '../../../../moreCore/UI/Container/uiFrame';

import { TabContainer } from "../../../../moreCore/_loadingHelpers/Tabbing";

import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";

class ServiceContractEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private allowButtons = false;

    private inputAccountClient: MdsLax<InstanceType<typeof HintBox>>;
    private inputAddress: MdsLax<InstanceType<typeof HintBox>>;

    setup(entity: DocumentEntity, tabContainer?: MdsLax<InstanceType<typeof TabContainer>>, node?: HTMLElement): void {
        let heading;

        this.setData(entity);
        this.setStartupState("ready");

        if (node) {
            this.show("node", heading, null, node)
        } else if (tabContainer) {
            this.show("tab", heading, tabContainer.name);
        }
        else {
            this.show("dlg", heading);
        }

        if (this.allowButtons) this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false, "primary");
    }

    //LOAD
    private _loadEntity(entityId: string): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);
        this.RequestManager.callfunction(
            "Webtool_API_Document__ServiceContractEditor_LoadEntity",
            { ID: entityId },
            lang.hitch(this, this._onLoadEntityResponse),
            lang.hitch(this, this._onLoadEntityError));
    }

    private _onLoadEntityResponse(response: any): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        response.is_new = false;
        this.setData(response);

    }

    private _onLoadEntityError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
    }

    //SAVE
    private _onClickSave(): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);

        let entityId = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        let isNew = this.getAttributeValue("is_new");
        let changedData = this.getChangedData();
        this.RequestManager.callfunction(
            "Webtool_API_Document__ServiceContractEditor_SaveEntity",
            { ID: entityId, Classname: classname, is_new: isNew, changedData: changedData },
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._onSaveError));
    }

    private _onSaveResponse(response): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.debug(response);
        this.emit("changed");
        this.emit("saved");
        this.showToast("Editor_Success_Save", "fas fa-check");
        this._loadEntity(response.entityId);
    }

    private _onSaveError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
        this.showToast("Editor_Error_Save", "fas fa-warning-triangle");
    }

    //ROLLBACK
    private _onClickRollback(e: MouseEvent): void {
        this.rollback();
    }

    //RELOAD
    private _onClickReload(e: MouseEvent): void {
        let entity = this.getAttributeValue("___root");
        this._loadEntity(entity.ID);
    }

    //DELETE
    private _onClickDelete(e: MouseEvent): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);
        let entityId = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        this.RequestManager.callfunction(
            "Webtool_API_Document__ServiceContractEditor_DeleteEntity",
            { ID: entityId, Classname: classname },
            lang.hitch(this, this._onDeleteResponse),
            lang.hitch(this, this._onDeleteError));
    }

    private _onDeleteResponse(response): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.debug(response);
        this.emit("changed");
        this.close();
        this.showToast("Editor_Success_Delete", "fas fa-check");
    }

    private _onDeleteError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
        this.showToast("Editor_Error_Delete", "fas fa-warning-triangle");
    }


    //BUTTONS
    private _deactivateDataButtons(deactivate: boolean, deactivateAll?: boolean): void {
        this.requestContextButtonDisable("save", deactivate);
        this.requestContextButtonDisable("rollback", deactivate);
        if (deactivateAll) {
            this.requestContextButtonDisable("delete", deactivate);
            this.requestContextButtonDisable("reload", deactivate);
        }
    }

    //STATEFULSECTION
    protected onDirtyChange(newState: boolean) {
        this._deactivateDataButtons(!newState);
        this.setDirtyMarker(newState);
    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {
            
        }

        this.emit("changed", this.changedData);
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let isNew = this.getAttributeValue("is_new");
        if (!isNew) {
            if (this.allowButtons) this.createDefaultButton("delete", lang.hitch(this, this._onClickDelete), true, "secondary");
            if (this.allowButtons) this.createDefaultButton("rollback", lang.hitch(this, this._onClickRollback), false, "secondary");
            if (this.allowButtons) this.createDefaultButton("reload", lang.hitch(this, this._onClickReload), true, "primary");
            this.changeInternalName("ServiceContractEditor_Editor_" + this.getAttributeValue("ID"));
            //this.setTitles(`${this.translate("NAMESPACE_Heading_ServiceContractEditor")}: ${this.getAttributeValue("ATTRIBUTENAME")}`);
        } else {

        }
        this._deactivateDataButtons(true);
        this.inputAddress.addAdditionalRequestParameter("serviceContract", this.getAttributeValue("___root"));
        this.inputAddress.setReadonly(this.isReadonly() || false);
    }

    //UIFRAMEMIXIN
    //UIFRAMEMIXIN
    _onCloseRequest() {
        let hasChanged = this.isDirty() === true;

        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translate("Document_ServiceContractEditor_AskSavePendingChanges"),
                this.translate("General_PendingChanges") + " - " + this.title,
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result): void {
        if (result == -1) { // nein
            this.emit("notSaved");
            this.close();
        } else if (result == 0) { // cancel
            this.emit("canceled");
        }
        else {
            this._onClickSave();
            this.on("saved", lang.hitch(this, this.close));
        }
    }

    //GlobalSelectEntityDialogMixin
    private _onClickSEDButton(mode: string, evt: MouseEvent): void {
        let additionalRequestData = null;

        switch (mode) {
            case "address":
                additionalRequestData = { serviceContract: this.getAttributeValue("___root") };
                break;
        }

        this.openSelectEntityDialog(evt, mode, lang.hitch(this, this._onSEDCallback), null, additionalRequestData);
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<DocumentAddress>>) {
        let entity;
        if (items && items.length >= 0) entity = items[0].entry.data;
        else return;

        switch (mode) {
            case "accountClient":
                this.setAttributeValue("ref_account_client", entity);
                break;
            case "address":
                this.setAttributeValue("ref_address", entity);
                break;
        }
    }

    //WIDGETBASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API_Document__DocumentEditor_GetSEDConfig";

        this.inputAccountClient.addInlineButton(lang.hitch(this, this._onClickSEDButton, "accountClient"));
        this.inputAddress.addInlineButton(lang.hitch(this, this._onClickSEDButton, "address"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServiceContractEditor);